import { Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Tooltip } from "@mui/material";
import classes from "./location.module.css";
import { formatBytes } from "../../../utilities/commonFunctions";


import Dropzone from "react-dropzone";
import { useDispatch, useSelector } from "react-redux";
import { getLanguagedataFunction } from "../../../utilities/language";
import { DeleteBinIcons } from "../../../components/Icons";
import { decodeFileName } from "../../../utilities/fileName";
import {
  ATTACHMENT_ACCEPT,
  isImageAttachment,
  resolveAttachmentUrl,
} from "../../../utilities/attachments";
import AttachmentTile from "../../../components/AttachmentTile";

const Basic = ({ images, onDropFunction }) => {
  const dispatch = useDispatch();
  const [files, setFiles] = useState([]);
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [currentFiles, setcurrentFiles] = useState([]);
  // eslint-disable-next-line unused-imports/no-unused-vars
  const imageList = useSelector((state) => state.location.imageList);
  const ln = useSelector((state) => state.allUsers.language_json);

  React.useEffect(() => {
    getLanguagedataFunction(dispatch);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!ln]);

  const onDrop = (acceptedFiles) => {
    try {
      const newArray = [...files, ...acceptedFiles];
      console.log(newArray);

      setFiles(newArray);
      onDropFunction(newArray);
    } catch (error) {
      console.error("Error updating state:", error);
    }
  };

  useEffect(() => {
    if (images && images.length > 0) {
      setFiles([...images]);
    }
  }, [images]);

  const remove = (filename) => {
    try {
      const newList = files.filter(
        (item) => item.filename !== filename && item.name !== filename
      );
      setFiles([...newList]);
      onDropFunction(newList);
    } catch (error) {
      console.error("Error updating state:", error);
    }
  };
  const filenameConvert = (filename) => {
    filename = decodeFileName(filename) || "";
    const spliteName = filename.split(".");
    console.log(spliteName);

    if (spliteName[0].length > 10) {
      filename = filename.substring(0, 10);
      return filename + "." + spliteName[spliteName.length - 1];
    }
    return filename;
  };
  return (
    <div>
      {ln ? (
        <div className={classes.DropZoneContainer}>
          <Dropzone onDrop={onDrop} accept={ATTACHMENT_ACCEPT}>
            {({ getRootProps, getInputProps }) => (
              <div {...getRootProps({ className: classes.DropZone })}>
                <input {...getInputProps()} />
                <Button variant="contained" className={classes.DropzoneBtn}>
                  {ln.browse}
                </Button>
                <div>{ln.drop_here}</div>
              </div>
            )}
          </Dropzone>
          {window.location.pathname.includes("update") &&
          files &&
          files.length > 0 ? (
            <div className={classes.imageContainer}>
              {files.map((item) => {
                const url = resolveAttachmentUrl(item);
                return (
                  <div
                    className={classes.subImageContainer}
                    key={item.filename || item.name}
                  >
                    {isImageAttachment(item) ? (
                      <img
                        src={url}
                        width="250px"
                        height="150px"
                        style={{ maxHeight: "250px" }}
                        alt={decodeFileName(item.originalname || item.name)}
                      />
                    ) : (
                      <AttachmentTile item={item} url={url} />
                    )}
                    <div className={classes.imageText}>
                      <Tooltip title={decodeFileName(item.originalname || item.name)}>
                        <Typography
                          className={`${classes.form_lable} ${classes.detailsText1}`}
                          noWrap
                          style={{
                            overflow: "hidden",
                            width: "150px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {filenameConvert(item.originalname || item.name)}
                          {/* {item.originalname || item.name} */}
                        </Typography>
                      </Tooltip>

                      <div style={{ display: "flex", columnGap: "10px" }}>
                        {item.size ? (
                          <Typography className={`${classes.form_lable_size}`}>
                            {formatBytes(item.size)}
                          </Typography>
                        ) : null}
                        <Typography
                          className={`${classes.form_lable} ${classes.ImageDeleteBtn}`}
                          onClick={() => remove(item.filename)}
                        >
                          <DeleteBinIcons />
                        </Typography>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : null}
          {window.location.pathname.includes("create") &&
          files &&
          files.length > 0 ? (
            <div className={classes.imageContainer}>
              {files.map((item, index) => {
                const url = URL.createObjectURL(item);
                return (
                  <div className={classes.subImageContainer} key={index}>
                    {isImageAttachment(item) ? (
                      <img src={url} width="250px" height="150px" alt={item.name} />
                    ) : (
                      <AttachmentTile item={item} url={url} />
                    )}
                    <div className={classes.imageText}>
                      <Tooltip title={item.name}>
                        <Typography
                          className={`${classes.form_lable} ${classes.detailsText1}`}
                          noWrap
                          style={{
                            overflow: "hidden",
                            width: "150px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {item.name}
                        </Typography>
                      </Tooltip>

                      <div
                        style={{
                          display: "flex",
                          columnGap: "10px",
                          alignItems: "center",
                          marginTop: "4px",
                        }}
                      >
                        {item.size ? (
                          <Typography
                            className={`${classes.form_lable}`}
                            style={{
                              fontSize: "13px",
                            }}
                          >
                            {formatBytes(item.size)}
                          </Typography>
                        ) : null}
                        <Typography
                          className={`${classes.form_lable} ${classes.ImageDeleteBtn}`}
                          onClick={() => remove(item.name)}
                        >
                          <DeleteBinIcons />
                        </Typography>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : null}
        </div>
      ) : null}
    </div>

    // <section>
    //   <div {...getRootProps({ className: classes.DropZone })}>
    //     <input
    //       {...getInputProps({
    //         onChange: handleFile,
    //       })}
    //     />
    //     <Button variant="contained" className={classes.DropzoneBtn}>
    //       Browse
    //     </Button>
    //     <div>Or drop file here</div>
    //   </div>
    //   <aside>{files}</aside>
    // </section>
  );
};

export default Basic;
